import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Bouton flottant « Haut » — apparaît après un peu de défilement, sur TOUTES les
// pages (monté une fois dans App). Placé juste au-dessus de la bulle Messenger.
export default function ScrollTop() {
  const [visible, setVisible] = useState(false);
  const [bubbleOpen, setBubbleOpen] = useState(false);  // menu Messenger ouvert : on s'efface

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    const onBubble = (e) => setBubbleOpen(!!e.detail);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("mt-bubble", onBubble);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mt-bubble", onBubble);
    };
  }, []);

  // Remontée robuste : window + documentElement + repli instantané si rien n'a
  // bougé après 600 ms (Safari capricieux, conteneur à défilement interne…)
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      if (window.scrollY > 50) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    }, 600);
  };

  return (
    <button type="button" aria-label="Haut de page" data-testid="scroll-top" title="Haut de page"
      onClick={toTop}
      className={`fixed bottom-40 right-6 z-[9980] w-11 h-11 rounded-full border border-gold/50 bg-surface/90 backdrop-blur text-gold flex items-center justify-center shadow-[0_8px_24px_rgba(0,0,0,0.45)] hover:bg-gold hover:text-ink transition-all duration-300 ${visible && !bubbleOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}>
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
